@if (appointments$ | async; as events) {
    <form [formGroup]="form">
        <div class="is-paddingless mb-1">
            <div
                class="columns is-marginless is-fullwidth is-desktop is-gapless box-two-slot is-justified-center-desktop"
            >
                <div
                    [ngClass]="{ 'is-hidden-mobile is-hidden-tablet-only': isMobileAppointmentsBlockVisible }"
                    class="column padding-12 is-5-widescreen box is-marginless"
                >
                    <div class="is-shadowless calendar-box">
                        <div class="tabs has-text-centered" data-tabs-context>
                            <div class="is-flex is-justified-center tab-list">
                                <button
                                    data-tab-navigation
                                    class="tab {{ prevBtnDisabled ? 'is-invisible' : '' }}"
                                    (click)="decrement()"
                                    role="tab"
                                >
                                    <div class="tab-icon">
                                        <span class="icon is-small">
                                            <i class="tri-arrow-left" aria-hidden="true"></i>
                                        </span>
                                    </div>
                                </button>
                                <button data-tab-navigation class="tab is-capitalized" role="tab">
                                    {{ viewDate | calendarDate: view + 'ViewTitle' }}
                                </button>
                                <button
                                    data-tab-navigation
                                    class="tab {{ nextBtnDisabled ? 'is-invisible' : '' }}"
                                    (click)="increment()"
                                    role="tab"
                                >
                                    <div class="tab-icon">
                                        <span class="icon is-small">
                                            <i class="tri-arrow-right" aria-hidden="true"></i>
                                        </span>
                                    </div>
                                </button>
                            </div>
                        </div>
                        <div>
                            @switch (view) {
                                @case ('month') {
                                    <mwl-calendar-month-view
                                        [viewDate]="viewDate"
                                        [activeDay]="selectedDay"
                                        [events]="events"
                                        [refresh]="refreshSubject"
                                        [cellTemplate]="customCellTemplate"
                                        (dayClicked)="handleSelectedDay($event.day, true)"
                                        (beforeViewRender)="beforeMonthViewRender($event)"
                                        [weekStartsOn]="weekStartsOn"
                                    />
                                }
                            }
                        </div>
                    </div>
                    <div class="is-hidden-desktop">
                        <ng-container *ngTemplateOutlet="rdvLivraisonMessageValidation"></ng-container>
                    </div>
                </div>
                <div
                    [ngClass]="{ 'is-hidden-mobile is-hidden-tablet-only': !isMobileAppointmentsBlockVisible }"
                    class="column is-4-widescreen is-marginless is-paddingless box-choose-slot"
                >
                    <div class="box is-fullheight">
                        <div class="box-content padding-12 has-background-grey-fade is-growless">
                            <div
                                class="appointments-header columns is-mobile is-marginless is-paddingless is-aligned-center"
                            >
                                <div class="column is-narrow is-hidden-desktop">
                                    <a (click)="closeMobileAppointmentsBlock()" class="link">Retour</a>
                                </div>
                                <div class="column">
                                    <p class="text is-1 has-text-weight-bold has-text-centered">
                                        {{ headerTextAppointment }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="box-content padding-12">
                            @if (dayAppointments) {
                                <div>
                                    <div class="columns is-multiline is-mobile">
                                        @for (dayAppointment of dayAppointments; track dayAppointment) {
                                            <div class="radio column is-6">
                                                <input
                                                    formControlName="appointment"
                                                    name="appointment"
                                                    type="radio"
                                                    [id]="dayAppointment.id + '-' + dayAppointment.start.getTime()"
                                                    [value]="dayAppointment.meta"
                                                />
                                                <label
                                                    (click)="setAppointment(dayAppointment)"
                                                    [for]="dayAppointment.id + '-' + dayAppointment.start.getTime()"
                                                    class="radio-label"
                                                >
                                                    {{ dayAppointment.title }}
                                                </label>
                                            </div>
                                        }
                                    </div>

                                    @if (!appointment && !!currentAppointmentError) {
                                        <div class="error-block is-flex rows is-marginless mb-3">
                                            <div class="alert has-body is-danger">
                                                <div class="icon">
                                                    <i class="tri-exclamation-circle"></i>
                                                </div>
                                                <div class="body">
                                                    <p
                                                        class="text is-1 help is-error"
                                                        [innerHTML]="currentAppointmentError | trustHtml"
                                                    ></p>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    <ng-container *ngTemplateOutlet="rdvLivraisonMessageValidation"></ng-container>
                                </div>
                            } @else if (!appointment && !currentAppointmentError) {
                                <div
                                    class="no-selected-date-body is-flex rows is-justified-center is-aligned-center is-marginless"
                                >
                                    <div>
                                        <span class="icon is-medium">
                                            <i class="tri-calendar-question-circle"></i>
                                        </span>
                                    </div>
                                    <p class="has-text-centered text is-1 has-text-weight-bold">
                                        Vous n'avez pas encore sélectionné de date dans le calendrier
                                    </p>
                                </div>
                            } @else if (!appointment && !!currentAppointmentError) {
                                <div class="error-block is-flex rows is-marginless">
                                    <div class="filler is-flex is-justified-center is-aligned-center">
                                        <span class="icon is-large">
                                            <i class="tri-calendar-question-circle"></i>
                                        </span>
                                    </div>
                                    <div class="alert has-body is-danger">
                                        <div class="icon">
                                            <i class="tri-exclamation-circle"></i>
                                        </div>
                                        <div class="body">
                                            <p
                                                class="text is-1 help is-error"
                                                [innerHTML]="currentAppointmentError | trustHtml"
                                            ></p>
                                        </div>
                                    </div>
                                </div>
                            } @else if (appointment && !!currentAppointmentError) {
                                <div class="error-block is-flex rows is-marginless">
                                    <div class="filler is-flex is-justified-center is-aligned-center">
                                        <span class="icon is-large">
                                            <i class="tri-calendar-question-circle"></i>
                                        </span>
                                    </div>
                                    <div class="alert has-body is-info">
                                        <div class="icon">
                                            <i class="tri-exclamation-circle"></i>
                                        </div>
                                        <div class="body">
                                            <p class="text is-1" [innerHTML]="currentAppointmentError | trustHtml"></p>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <ng-template #customCellTemplate let-day="day" let-locale="locale">
        <div class="cal-cell-top">
            <span
                checkoutCy="cal-day-number-{{ day.date | calendarDate: 'monthViewDayNumber' : locale }}"
                class="cal-day-number"
                [ngClass]="{ active: day.badgeTotal > 0 }"
            >
                {{ day.date | calendarDate: 'monthViewDayNumber' : locale }}
            </span>
            @if (day.badgeTotal > 0) {
                <span class="cal-day-badge">{{ day.badgeTotal }}</span>
            }
        </div>
    </ng-template>
    <ng-template #rdvLivraisonMessageValidation>
        @if (appointment && !currentAppointmentError) {
            <div class="alert has-body is-info">
                <span class="icon">
                    <i class="tri-calendar-plus" aria-hidden="true"></i>
                </span>
                <div class="body">
                    <p class="text is-level-2">
                        @if (isPreselectedDate) {
                            <span>Votre rendez-vous présélectionné:</span>
                        }
                        @if (!isPreselectedDate) {
                            <span>Vous avez choisi&nbsp;: le&nbsp;</span>
                        }
                        <span class="has-text-weight-bold">{{ appointment.start | date: 'EEEE dd/MM' }}</span>
                        entre
                        <span class="has-text-weight-bold">{{ appointment.start | date: 'HH:mm' }}</span>
                        et
                        <span class="has-text-weight-bold">{{ appointment.end | date: 'HH:mm' }}</span>
                    </p>
                    @if (isPreselectedDate) {
                        <p>Vous pouvez cliquer sur une autre date pour le modifier.</p>
                    }
                </div>
            </div>
        }
    </ng-template>
} @else {
    <p class="has-text-centered mb-1">
        <span class="icon-and-text">
            <span class="icon is-small is-rotating"><i class="tri-logo"></i></span>
            <span>Chargement en cours...</span>
        </span>
    </p>
}
